import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { ModifierDto } from '../dtos';

export enum ModifiersActionTypes {
  LoadModifiers = '[Modifiers] LoadModifiers',
  LoadModifiersSuccess = '[Modifiers] LoadModifiersSuccess',
  LoadModifiersError = '[Modifiers] LoadModifiersError',
}

export const loadModifiersAction = createAction(ModifiersActionTypes.LoadModifiers);
export const loadModifiersSuccessAction = createAction(ModifiersActionTypes.LoadModifiersSuccess, props<{ modifiers: ModifierDto[] }>());
export const loadModifiersErrorAction = createAction(ModifiersActionTypes.LoadModifiersError, props<{ failure: AppStateFailure }>());
